module.exports = __webpack_public_path__ + "assets/images/premium-features/projected-sales-6c4800.png";